export default __webpack_public_path__ + "static/media/filterIcon.1c2f5075.svg";